import { Stack, TextField, Typography ,Button, Menu, MenuItem, Select, Grid, FormControl, Radio, Paper, IconButton, Box, useTheme, useMediaQuery} from '@mui/material'
import { LoadingButton } from '@mui/lab'
import React, { useEffect, useState } from 'react'
import { Cart } from '../../cart/components/Cart'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { addAddressAsync, selectAddressStatus, selectAddresses } from '../../address/AddressSlice'
import { selectLoggedInUser } from '../../auth/AuthSlice'
import { Link, useNavigate } from 'react-router-dom'
import { createOrderAsync, selectCurrentOrder, selectOrderStatus } from '../../order/OrderSlice'
import { resetCartByUserIdAsync, selectCartItems } from '../../cart/CartSlice'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { SHIPPING, TAXES } from '../../../constants'
import {motion} from 'framer-motion'
import { toast } from 'react-toastify'

export const Checkout = () => {

    const status=''
    const addresses=useSelector(selectAddresses)
    const [selectedAddress,setSelectedAddress]=useState(addresses[0])
    const [selectedPaymentMethod,setSelectedPaymentMethod]=useState('')
    const { register, handleSubmit, watch, reset,formState: { errors }} = useForm()
    const dispatch=useDispatch()
    const loggedInUser=useSelector(selectLoggedInUser)
    const addressStatus=useSelector(selectAddressStatus)
    console.log('checkout',addresses.length);
    const navigate=useNavigate()
    const cartItems=useSelector(selectCartItems)
    const orderStatus=useSelector(selectOrderStatus)
    const currentOrder=useSelector(selectCurrentOrder)
    const orderTotal=cartItems.reduce((acc,item)=>(item.product.price*item.quantity)+acc,0)
    const theme=useTheme()
    const is900=useMediaQuery(theme.breakpoints.down(900))
    const is480=useMediaQuery(theme.breakpoints.down(480))
    
    useEffect(()=>{
        if(addressStatus==='fulfilled'){
            reset()
        }
        else if(addressStatus==='rejected'){
            alert('Error adding your address')
        }
    },[addressStatus])

    useEffect(()=>{
        // console.log("🔥 currentOrder =", currentOrder)
        if(currentOrder && currentOrder?._id){
            dispatch(resetCartByUserIdAsync(loggedInUser?._id))
            navigate(`/order-success/${currentOrder?._id}`)
        }
    },[currentOrder])
    
    const handleAddAddress=(data)=>{
        const address={...data,user:loggedInUser._id}
        dispatch(addAddressAsync(address))
    }

    const handleCreateOrder = () => {
        console.log(selectedAddress)
        if (addresses.length === 0) {

            if (!selectedAddress || !selectedAddress._id) {
                toast.error("Please select or add your address before placing the order");

                // Scroll to top so user can see the form
                window.scrollTo({ top: 0, behavior: "smooth" });

                return; // Stop order submission
            }

        }

        if(selectedAddress == undefined){
            toast.error("Please select your address before placing the order");
            // Scroll to top so user can see the form
            window.scrollTo({ top: 500, behavior: "smooth" });
            return;
        }

        if (!selectedPaymentMethod) {
            toast.error("Please select a payment method");

            window.scrollTo({ top: 1000, behavior: "smooth" });

            return;
        }

        const order = { user: loggedInUser._id, item: cartItems, address: selectedAddress, paymentMode: selectedPaymentMethod, total: orderTotal + SHIPPING + TAXES }
        // console.log('ff',order)
        dispatch(createOrderAsync(order))
    }

  return (
    <Stack flexDirection={'row'} p={2} rowGap={10} justifyContent={'center'} flexWrap={'wrap'} mb={'5rem'} mt={2} columnGap={4} alignItems={'flex-start'}>

        {/* left box */}
        <Stack rowGap={4}>

            {/* heading */}
            <Stack flexDirection={'row'} columnGap={is480?0.3:1} alignItems={'center'}>
                <motion.div  whileHover={{x:-5}}>
                    <IconButton component={Link} to={"/cart"}><ArrowBackIcon fontSize={is480?"medium":'large'}/></IconButton>
                </motion.div>
                <Typography variant='h4'>Shipping Information</Typography>
            </Stack>

            {/* address form */}
            {/* <Stack component={'form'} noValidate rowGap={2} onSubmit={handleSubmit(handleAddAddress)}>
                    <Stack>
                        <Typography  gutterBottom>Type</Typography>
                        <TextField placeholder='Eg. Home, Buisness' {...register("type",{required:true})}/>
                    </Stack>


                    <Stack>
                        <Typography gutterBottom>Street</Typography>
                        <TextField {...register("street",{required:true})}/>
                    </Stack>

                    <Stack>
                        <Typography gutterBottom>Country</Typography>
                        <TextField defaultValue="Pakistan" disabled {...register("country",{required:true})}/>
                    </Stack>

                    <Stack>
                        <Typography  gutterBottom>Phone Number</Typography>
                        <TextField type='number' {...register("phoneNumber",{required:true})}/>
                    </Stack>

                    <Stack flexDirection={'row'}>
                        <Stack width={'100%'}>
                            <Typography gutterBottom>City</Typography>
                            <TextField  {...register("city",{required:true})}/>
                        </Stack>
                        <Stack width={'100%'}>
                            <Typography gutterBottom>State</Typography>
                            <TextField defaultValue="punJab" disabled {...register("state",{required:true})}/>
                        </Stack>
                        <Stack width={'100%'}>
                            <Typography gutterBottom>Postal Code</Typography>
                            <TextField defaultValue="3800" disabled type='number' {...register("postalCode",{required:true})}/>
                        </Stack>
                    </Stack>

                    <Stack flexDirection={'row'} alignSelf={'flex-end'} columnGap={1}>
                        <LoadingButton loading={status==='pending'} type='submit' variant='contained'>add</LoadingButton>
                        <Button color='error' variant='outlined' onClick={()=>reset()}>Reset</Button>
                    </Stack>
            </Stack> */}

              {/* ADDRESS FORM */}
              <Stack component={'form'} noValidate rowGap={2} onSubmit={handleSubmit(handleAddAddress)}>

                  {/* Email */}
                  {/* <Stack>
                      <Typography gutterBottom>Email</Typography>
                      <TextField
                          placeholder="Enter your email"
                          {...register("email", {
                              required: "Email is required",
                              pattern: {
                                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                  message: "Invalid email format"
                              }
                          })}
                          error={!!errors.email}
                          helperText={errors.email?.message}
                      />
                  </Stack> */}

                  {/* Type */}
                  <Stack>
                      <Typography gutterBottom>Type</Typography>
                      <TextField
                          placeholder='Eg. Home, Business'
                          {...register("type", { required: "Address type is required" })}
                          error={!!errors.type}
                          helperText={errors.type?.message}
                      />
                  </Stack>

                  {/* Street */}
                  <Stack>
                      <Typography gutterBottom>Street</Typography>
                      <TextField
                          {...register("street", { required: "Street address is required" })}
                          error={!!errors.street}
                          helperText={errors.street?.message}
                      />
                  </Stack>

                  {/* Country */}
                  <Stack>
                      <Typography gutterBottom>Country</Typography>
                      <TextField
                          defaultValue="Pakistan"
                          InputProps={{ readOnly: true }}
                          {...register("country")}
                      />
                  </Stack>

                  {/* Phone Number */}
                  <Stack>
                      <Typography gutterBottom>Phone Number</Typography>
                      <TextField
                          type='number'
                          placeholder="03XX-XXXXXXX"
                          {...register("phoneNumber", {
                              required: "Phone number is required",
                              minLength: { value: 11, message: "Enter a valid 11-digit phone number" },
                              maxLength: { value: 11, message: "Enter a valid 11-digit phone number" }
                          })}
                          error={!!errors.phoneNumber}
                          helperText={errors.phoneNumber?.message}
                      />
                  </Stack>

                  {/* City + State + Postal */}
                  <Stack flexDirection={'row'} columnGap={2}>

                      {/* City */}
                      <Stack width={'100%'}>
                          <Typography gutterBottom>City</Typography>
                          <TextField
                              {...register("city", { required: "City is required" })}
                              error={!!errors.city}
                              helperText={errors.city?.message}
                          />
                      </Stack>

                      {/* State */}
                      <Stack width={'100%'}>
                          <Typography gutterBottom>State</Typography>
                          <TextField
                              defaultValue="Punjab"
                              InputProps={{ readOnly: true }}
                              {...register("state")}
                          />
                      </Stack>

                      {/* Postal Code */}
                      <Stack width={'100%'}>
                          <Typography gutterBottom>Postal Code</Typography>
                          <TextField
                              defaultValue="38000"
                              InputProps={{ readOnly: true }}
                              type='number'
                              {...register("postalCode")}
                          />
                      </Stack>
                  </Stack>

                  {/* Buttons */}
                  <Stack flexDirection={'row'} alignSelf={'flex-end'} columnGap={1}>
                      <LoadingButton loading={status === 'pending'} type='submit' variant='contained'>
                          Add
                      </LoadingButton>
                      <Button color='error' variant='outlined' onClick={() => reset()}>
                          Reset
                      </Button>
                  </Stack>

              </Stack>


            {/* existing address */}
            <Stack rowGap={3}>

                <Stack>
                    <Typography variant='h6'>Address</Typography>
                    <Typography variant='body2' color={'text.secondary'}>Choose from existing Addresses</Typography>
                </Stack>

                <Grid container gap={2} width={is900?"auto":'50rem'} justifyContent={'flex-start'} alignContent={'flex-start'}>
                        {
                            addresses.map((address,index)=>(
                                <FormControl item >
                                    <Stack key={address._id} p={is480?2:2} width={is480?'100%':'20rem'} height={is480?'auto':'15rem'}  rowGap={2} component={is480?Paper:Paper} elevation={1}>

                                        <Stack flexDirection={'row'} alignItems={'center'}>
                                            <Radio checked={selectedAddress===address} name='addressRadioGroup' value={selectedAddress} onChange={(e)=>setSelectedAddress(addresses[index])}/>
                                            <Typography>{address.type}</Typography>
                                        </Stack>

                                        {/* details */}
                                        <Stack>
                                            <Typography>{address.street}</Typography>
                                            <Typography>{address.state}, {address.city}, {address.country}, {address.postalCode}</Typography>
                                            <Typography>{address.phoneNumber}</Typography>
                                        </Stack>
                                    </Stack>
                                </FormControl>
                            ))
                        }
                </Grid>

            </Stack>
            
            {/* payment methods */}
            <Stack rowGap={3}>

                    <Stack>
                        <Typography variant='h6'>Payment Methods</Typography>
                        <Typography variant='body2' color={'text.secondary'}>Please select a payment method</Typography>
                    </Stack>
                    
                    <Stack rowGap={2}>

                        <Stack flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'}>
                            <Radio value={selectedPaymentMethod} name='paymentMethod' checked={selectedPaymentMethod==='COD'} onChange={()=>setSelectedPaymentMethod('COD')}/>
                            <Typography>Cash On Delivery</Typography>
                        </Stack>

                        {/* <Stack flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'}>
                            <Radio value={selectedPaymentMethod} name='paymentMethod' checked={selectedPaymentMethod==='CARD'} onChange={()=>setSelectedPaymentMethod('CARD')}/>
                            <Typography>Card</Typography>
                        </Stack> */}

                    </Stack>


            </Stack>
        </Stack>

        {/* right box */}
        <Stack  width={is900?'100%':'auto'} alignItems={is900?'flex-start':''}>
            <Typography variant='h4'>Order summary</Typography>
            <Cart checkout={true}/>
            <LoadingButton fullWidth loading={orderStatus==='pending'} variant='contained' onClick={handleCreateOrder} size='large'>Pay and order</LoadingButton>
        </Stack>

    </Stack>
  )
}
